// import { useState } from "react";
// import { Document, Page, pdfjs } from "react-pdf";
// import closeIcon from "../../assets/img/Path 49373.svg";
// import viewIcon from "../../assets/img/eye-look.svg";
// import downloadIcon from "../../assets/img/Download-icon.svg";
// import "./PatientReport.scss";

// pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

// const PatientReport = () => {
//   const [numPages, setNumPages] = useState(null);
//   const [modalPageNumber, setModalPageNumber] = useState(1);
//   const [modalIsOpen, setModalIsOpen] = useState(false);

//   function onDocumentLoadSuccess({ numPages }) {
//     setNumPages(numPages);
//   }

//   const docOrImg = [
//     {
//       name: "Blood Test",
//       file: "/docs/Blood-Test.pdf",
//       type: "pdf",
//     },
//     {
//       name: "CBC Test",
//       file: "/docs/CBC-Test.pdf",
//       type: "pdf",
//     },
//     {
//       name: "X-ray Test",
//       file: "/docs/X-ray-Test.jpg",
//       type: "jpg",
//     },
//     {
//       name: "Ultrasonography Test",
//       file: "/docs/Ultrasonography-Test.jpg",
//       type: "jpg",
//     },
//   ];
//   const [file, setFile] = useState(docOrImg[0].file);
//   const [fileType, setFileType] = useState(docOrImg[0].type);

//   return (
//     <>
//       {modalIsOpen ? (
//         <div className="modal">
//           <div className="modal-content">
//             <button
//               onClick={() => {
//                 setModalIsOpen(false);
//                 setModalPageNumber(1);
//               }}
//             >
//               <img src={closeIcon} alt="modal close" />
//             </button>
//             <div className="pdf-file">
//               {fileType === "pdf" ? (
//                 <Document file={file} onLoadSuccess={onDocumentLoadSuccess}>
//                   <Page pageNumber={modalPageNumber} />
//                 </Document>
//               ) : (
//                 <img src={file} alt="Test Report" className="report-photo" />
//               )}
//             </div>
//             {fileType === "pdf" && (
//               <div className="page-controls">
//                 <button
//                   type="button"
//                   onClick={() => setModalPageNumber(modalPageNumber - 1)}
//                   disabled={modalPageNumber === 1}
//                 >
//                   ‹
//                 </button>
//                 <span>
//                   {modalPageNumber} of {numPages}
//                 </span>
//                 <button
//                   type="button"
//                   onClick={() => setModalPageNumber(modalPageNumber + 1)}
//                   disabled={modalPageNumber === numPages}
//                 >
//                   ›
//                 </button>
//               </div>
//             )}
//           </div>
//         </div>
//       ) : null}
//       <div
//         className="screen4-card"
//         style={{
//           // backgroundImage: "url('../../assets/images/backgrounds/2.jpg')"
//           backgroundSize: "cover",
//           backgroundPosition: "center",
//         }}
//       >
//         <div className="screen4-card-top">
//           <p className="screen4-card-title">Recent Reports</p>
//           <button className="screen4-sort-by-button">
//             <span> Sort By </span>
//             <img src="/img/Expand-icon.svg" alt="down arrow" />
//           </button>
//         </div>
//         <hr class="screen-3-divider" />
//         <div className="screen4-report-container">
//           {docOrImg.map((item, i) => (
//             <>
//               <div className="screen4-report-item">
//                 <div className="screen4-report-content">
//                   {item.type === "pdf" ? (
//                     <Document
//                       file={item.file}
//                       onLoadSuccess={onDocumentLoadSuccess}
//                     >
//                       <Page pageNumber={1} />
//                     </Document>
//                   ) : (
//                     <img
//                       src={item.file}
//                       alt="test Report"
//                       className="screen4-report-photo"
//                     />
//                   )}
//                   <div>
//                     <a
//                       href="#"
//                       onClick={() => {
//                         setFile(item.file);
//                         setFileType(item.type);
//                         setModalIsOpen(true);
//                       }}
//                     >
//                       <p className="screen4-report-title">
//                         {item.name} Report- Neha Sen
//                       </p>
//                     </a>
//                     <p className="screen4-report-desc">
//                       Axfdhht Cinic
//                       <br />
//                       24th May, 2021
//                     </p>
//                   </div>
//                 </div>
//                 <div className="screen4-report-content">
//                   <div className=" screen4-report-buttons ">
//                     <p className="screen4-report-title">Dr. Samanta</p>

//                     <p className="screen4-report-desc">
//                       Axfdhht Cinic
//                       <br />
//                       24th May, 2021
//                     </p>
//                   </div>
//                 </div>
//                 <div className="screen4-report-buttons">
//                   <button
//                     className="screen4-report-button"
//                     onClick={() => {
//                       setFile(item.file);
//                       setFileType(item.type);
//                       setModalIsOpen(true);
//                     }}
//                   >
//                     <img src={viewIcon} alt="view button" />
//                     <span>View</span>
//                   </button>
//                   <a href={item.file} download={item.name}>
//                     <button className="screen4-report-button">
//                       <img src={downloadIcon} alt="view button" />
//                       <span>Download</span>
//                     </button>
//                   </a>
//                 </div>
//               </div>
//               <hr className="screen4-report-divider" />
//             </>
//           ))}
//         </div>
//       </div>
//     </>
//   );
// };

// export default PatientReport;
import React from 'react'

const PatientReport = () => {
  return (
    <div>PatientReport</div>
  )
}

export default PatientReport